/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Text from "../ui/Text";
import Button from "../ui/Button";
import DeletePaymentMethodModal from "./DeletePaymentMethodModal";
import { useAssetsSrc } from "../../hooks/useAssetsSrc";
import { PAYMENT_PROCESSORS_ICONS_PATH } from "../../constants/constants";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Flex from "../ui/Flex";

const PaymentMethodItemInner = styled(Flex)`
  padding: 1rem 1.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 1rem;
  }
`;

const LogoBox = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 60px;
  aspect-ratio: 16 / 9;
  padding: 0.25rem;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 0.5rem;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;


const PaymentMethodItem = ({ paymentMethod }) => {
  const logo = useAssetsSrc(`${PAYMENT_PROCESSORS_ICONS_PATH}${paymentMethod.payment_system}.png`);

  return (
    <BookingStepItem>
      <PaymentMethodItemInner $align="center" $gap="1.5rem" $justify="space-between">
        <Flex $align="center" $gap="1.5rem">
          <LogoBox>
            <img src={logo} alt={paymentMethod.payment_system} />
          </LogoBox>
          <Text color="dark" weight="bold">
            {paymentMethod.name}
          </Text>
        </Flex>
        <DeletePaymentMethodModal
          paymentMethod={paymentMethod}
          trigger={<Button variant="danger" size="m" title="Delete" />}
        />
      </PaymentMethodItemInner>
    </BookingStepItem>
  );
};

export default PaymentMethodItem;
